import { escapeHtmlEntities, filterXSS, getDefaultWhiteList } from 'xss';
export const sanitizeHtml = function (html, xssOptions) {
  if (xssOptions === void 0) {
    xssOptions = {};
  }
  const options = {
    whiteList: {
      ...getDefaultWhiteList(),
      span: ['style'],
      // in the BO rich text component transform all changes to span with style
      div: ['style'],
      // allow to override common styles for components like Agent Tooltip content
      a: ['target', 'href', 'title', 'data-hook'],
      // added data-hook for testing
      source: ['src', 'type'],
      // correct playing video in attachments
      kbd: [],
      // multiline input field keyboard tips
      ol: ['class']
    },
    ...xssOptions
  };
  return filterXSS(html, options);
};
export const escapeHtml = value => {
  return escapeHtmlEntities(value);
};
export const sanitizeInput = input => filterXSS(input, {
  stripIgnoreTag: true,
  stripIgnoreTagBody: ['script']
});
//# sourceMappingURL=xss.js.map